import { Component, inject, input } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { WinShared } from '../../dialogs/win-shared/win-shared';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogConfig,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle,
} from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Downtime } from '../../../../core/services/times/downtime';

@Component({
  selector: 'app-shared',
  imports: [TranslatePipe, MatTooltipModule],
  templateUrl: './app-shared.html',
  styleUrl: './app-shared.scss'
})
export class AppShared {
  router = inject(Router);
  
  uuid = input<string>('');
  maxPlayers = input<number>(0);
  playersLen = input<number>(0);
  readonly dialog = inject(MatDialog);
  downtime = inject(Downtime);
  private translate = inject(TranslateService);

  openDialogLink(){
    this.downtime.refreshTimer();

    let copyUrl = `${location.origin}${this.router.createUrlTree(['/waiting',this.uuid(),{ share: true }]).toString()}`;
    const data = {
      type: 'wait',
      link: copyUrl
    }

    const dialogConfig = new MatDialogConfig();
    dialogConfig.panelClass = 'nutri-templs';
    dialogConfig.backdropClass = 'nutri-templs-backdrop';
    dialogConfig.data = data; 
    const dialogRef = this.dialog.open(WinShared, dialogConfig );

    dialogRef.afterClosed().subscribe(result => {
      
    });
  }

}
